import {UnassignPickupsSourceCd} from '../';
import {EnumHelper} from './enum-helper';

export class UnassignPickupsSourceCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in UnassignPickupsSourceCd ) {
      this._values.push(UnassignPickupsSourceCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): UnassignPickupsSourceCd {

    for ( const obj in UnassignPickupsSourceCd ) {
      if (UnassignPickupsSourceCd[obj] === value){
        return UnassignPickupsSourceCd[obj] as UnassignPickupsSourceCd;
      }
    }
  }
}

const UnassignPickupsSourceCdHelper = new UnassignPickupsSourceCdHelperEnumHelperClass();
export default UnassignPickupsSourceCdHelper;
